export default __webpack_public_path__ + "static/software-2-4bf366bcac4ba847567c9590d67f49eb.webp";